import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import UtilityHeader from '@aware/common/utility-header';
import Page from '@common/components/app-layout/page';
import PageContent from '@common/components/app-layout/page-content';
import V2Iframe from '@common/components/iframe-component/v2-iframe';

import { V2_ROUTE_PAGES } from '@aware/v2-routes/constants';

import {
  useSetOverrideBreadcrumbLink,
  useGetOverrideBreadcrumbLink
} from '@common/contexts/breadcrumb-link';

const InventoryDetail = () => {
  const { id } = useParams();
  const history = useHistory();

  /**
   * Need to explicitly set breadcrumb link, otherwise page will load default params, which would load
   * the wrong path
   */
  const breadcrumbKey = V2_ROUTE_PAGES.authorAssessments;
  const breadcrumbQueryParams = useGetOverrideBreadcrumbLink(breadcrumbKey);
  const { setOverrideLink } = useSetOverrideBreadcrumbLink(breadcrumbKey);
  useEffect(() => {
    if (!breadcrumbQueryParams) {
      setOverrideLink(`${V2_ROUTE_PAGES.authorAssessments}?tab=inventory`);
    }
  }, []);

  useEffect(() => {
    window.top.deleteStudentInventoryCallbackFn = () => {
      history.push(`${V2_ROUTE_PAGES.authorAssessments}?tab=inventory`);
    };

    return () => delete window.top.deleteStudentInventoryCallbackFn;
  }, []);

  const iframeSrc = `/aware/?embed=1&detailsSrc=/aware/Manage/StudentInventory/AssessmentDetails.aspx?aid=${id}`;

  const iframeName = 'Student Inventory Assessmment';

  const [title, setTitle] = useState('');

  return (
    <>
      <UtilityHeader title={title || iframeName} />
      <Page>
        <PageContent disableScroll>
          <V2Iframe
            iframeSrc={iframeSrc}
            name={iframeName}
            title={iframeName}
            onLoadCallback={iframe => {
              const inventoryName = iframe?.contentDocument
                ?.getElementById('detailsec1')
                .contentDocument?.getElementById('Tabstrip1_GeneralTab_txtTitle')?.value;
              setTitle(inventoryName || iframeName);
            }}
          />
        </PageContent>
      </Page>
    </>
  );
};

export default InventoryDetail;
